import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { HtmlTitle } from '@ocx-app/components/router/HtmlTitle';
import { BackButton } from '@ocx-app/components/Layout/NavigationBar/BackButton/BackButton';

import { Typography, NavigationBar, Page, PageContent } from '@ocx/ui';

import { pointExpirationScheduleMessages } from './point-expiration-schedule.messages';

type PointExpirationScheduleLayoutProps = {
  children: ReactNode;
};

export const PointExpirationScheduleLayout = ({ children }: PointExpirationScheduleLayoutProps) => {
  return (
    <Page>
      <HtmlTitle title={pointExpirationScheduleMessages['point-expiration-schedule:html-title']} />
      <NavigationBar
        left={<BackButton />}
        center={
          <Typography component="h2">
            <FormattedMessage {...pointExpirationScheduleMessages['point-expiration-schedule:page-title']} />
          </Typography>
        }
      />
      <PageContent>{children}</PageContent>
    </Page>
  );
};
